export const FileExtensions = {
  PDF: 'pdf',
};
